(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("meeseOSClient", [], factory);
	else if(typeof exports === 'object')
		exports["meeseOSClient"] = factory();
	else
		root["meeseOSClient"] = factory();
})(self, () => {
return 